import { Box, Progress } from "native-base";
import { COLORS } from "../../utils/colors";

const ProgressBar = ({
  width = "100%",
  bg = COLORS.RATINGS_SHADOW_COLOR,
  filledColor = COLORS.RATINGS_COLOR,
  value = 0,
  size = "md",
  ind = 0
}) => {
  return (
    <Box mt={2} width={width}>
      <Progress
        bg={bg}
        value={value}
        size={size}
        _filledTrack={{
          bg: filledColor,
        }}
      />
    </Box>
  );
};

export default ProgressBar;
